export default {
  id: {
    value: '',
    maxlength: '60',
    required: false,
    state: null,
    defaultValue: ''
  },
  regulationAutoID: {
    value: '',
    maxlength: '60',
    required: true,
    state: null,
    defaultValue: ''
  },
  initialSurveyBudgetedLabor: {
    value: 0,
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  initialSurveyApprovedLabor: {
    value: 0,
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  insuranceBudgetedLabor: {
    value: 0,
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  insuranceApprovedLabor: {
    value: 0,
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  description: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '2',
    noResize: true,
    defaultValue: ''
  },
  actionDate: {
    value: '',
    maxlength: '30',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/inspection/typing/sinistertyping-form.js